import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { ScrollText } from "lucide-react";

export default function AdminActivity() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/activity-logs").then((r) => setLogs(r.data)); }, []);
  return (
    <div data-testid="admin-activity">
      <h1 className="font-serif text-3xl text-navy mb-1">Activity Logs</h1>
      <p className="text-sm text-muted-foreground mb-6">Audit trail of admin actions across the platform.</p>
      {logs.length === 0 ? (
        <div className="bg-white rounded-xl border border-black/5 p-12 text-center text-muted-foreground"><ScrollText className="mx-auto mb-3 text-gold" size={30} />No activity recorded yet.</div>
      ) : (
        <div className="bg-white rounded-xl border border-black/5 divide-y divide-black/5">
          {logs.map((l) => (
            <div key={l.id} className="flex items-center gap-4 p-4" data-testid={`activity-${l.id}`}>
              <span className="w-9 h-9 rounded-full bg-beige text-gold flex items-center justify-center shrink-0"><ScrollText size={15} /></span>
              <div className="flex-1"><div className="text-sm text-navy font-medium">{l.action}{l.detail ? <span className="text-muted-foreground font-normal"> — {l.detail}</span> : ""}</div><div className="text-xs text-muted-foreground">{l.admin} · {l.admin_email}</div></div>
              <div className="text-xs text-muted-foreground shrink-0">{new Date(l.created_at).toLocaleString("en-IN")}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
